const DEFAULT_LOCALE = 'en-GB';

const formatTimeLocaleDependent = (isoDate: string): string => {
  const date = new Date(isoDate);
  const locale = navigator.language || DEFAULT_LOCALE;

  const formatter = new Intl.DateTimeFormat(locale, {
    hour: 'numeric',
    minute: '2-digit',
  });

  return formatter.format(date);
};

export default formatTimeLocaleDependent;
